<div class="wrapper">
  <h1 class="bonus-segment-title">Программа лояльности</h1>

  @if (enabledBonusStatus$ | async) {
    <sd-bonus-status-block></sd-bonus-status-block>
  }

  <div class="bonus-title" id="bonus-history-list">События:</div>

  @let obs =
    {
      bonusHistory: bonusHistory$ | async,
      pagination: paginations$ | async,
    };

  @if (obs.bonusHistory && obs.bonusHistory.length > 0) {
    <div class="bonus-block">
      <sd-bonus-history-block [bonuses]="obs.bonusHistory"></sd-bonus-history-block>

      @if (obs.pagination && obs.pagination.totalPages > 0) {
        <div class="pagination-wrapper">
          <sd-pagination
            [pagination]="obs.pagination"
            pageRoute="."
            queryParam="page"
            [defaultPage]="0"
          ></sd-pagination>
        </div>
      }
    </div>
  } @else {
    <div class="empty-bonus">Истории списаний и начислений баллов пока нет</div>
  }
</div>
